export default __webpack_public_path__ + "static/media/fisher Flanged Control.50251803.jpeg";